module.exports = __webpack_public_path__ + "img/succes.605e5208.png";